import { render, staticRenderFns } from "./phoneIndex.vue?vue&type=template&id=631853b3&scoped=true"
import script from "./phoneIndex.vue?vue&type=script&lang=js"
export * from "./phoneIndex.vue?vue&type=script&lang=js"
import style0 from "./phoneIndex.vue?vue&type=style&index=0&id=631853b3&prod&lang=scss&scoped=true"
import style1 from "./phoneIndex.vue?vue&type=style&index=1&id=631853b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631853b3",
  null
  
)

export default component.exports